export const APP_THEME_NAME_CONFIG = {
  DEFAULT: {
    RESULT_CRIMINAL_CARD: {
      noViolationText: 'Xe của bạn sạch như bảng điểm 10,\nkhông có lỗi phạt nguội nào!',
      checkedAtLabel: 'Tra cứu lúc'
    },
    LIST_CRIMINAL_RECORDS: {
      showHeaderIcon: true,
      showStatusIcon: true
    },
    TRAFFIC_FINE_CHECK_RESULT: {
      showPackageManagement: true,
      showCardIconsLinkSupport: true,
      primaryActionIfRegistered: 'GO_BACK',
      primaryActionTextIfRegistered: 'Tra cứu xe khác'
    },
    REGISTERED_PACKAGE_INFO: {
      cardLayoutVersion: 1,
      benefitsTitle: 'Quyền lợi của bạn'
    },
    TRAFFIC_FINE_PACKAGE_INFO: {
      showCardIconsLinkSupport: true
    },
    TRAFFIC_FINE_NOTIFICATION_SERVICES: {
      layoutVersion: 1
    },
    TRAFFIC_FINE_NOTIFICATION_VEHICLES: {
      layoutVersion: 1
    },
    AUTOMATED_TRAFFIC_FINE_NOTIFICATION_PAYMENT: {
      showTermsCheckbox: false,
      hidePaymentMethodSelector: false,
      buttonSubmitText: 'Tiếp theo',
      headerTitle: 'Tự động thông báo phạt nguội',
      transactionFeeLabel: 'Thuế VAT (10%)',
      isFreeTransactionFee: false,
      showVatNote: true,
      paymentMethodEmptyStateVariant: 1
    },
    TRAFFIC_FINE_REGISTRATION_MANAGEMENT: {
      headerStyleVersion: 1,
      firstTimeBannerVariant: 1,
      headerDescriptionText: 'Tự động thông báo lỗi phạt hằng tuần',
      showHeaderAddButton: true,
      showBottomRegisterButtonAlways: false,
      showBottomRegisterButtonIcon: false,
      showEmptyStateDescription: true,
      emptyStateTitle: 'Bạn chưa có xe nào được đăng ký',
      showHomeBanner: true
    },
    TRAFFIC_FINE_PHONE_AUTH: {
      phoneAuthBannerVariant: 1
    }
    // Các feature key khác sẽ được thêm vào đây
  },
  BIDV: {
    RESULT_CRIMINAL_CARD: {
      noViolationText: 'Xe của bạn không có lỗi \nphạt nguội nào!',
      checkedAtLabel: 'Thời gian tra cứu:'
    },
    LIST_CRIMINAL_RECORDS: {
      showHeaderIcon: false,
      showStatusIcon: false
    },
    TRAFFIC_FINE_CHECK_RESULT: {
      showPackageManagement: false,
      showCardIconsLinkSupport: true,
      primaryActionIfRegistered: 'MANAGE_PACKAGE',
      primaryActionTextIfRegistered: 'Quản lý gói thông báo'
    },
    REGISTERED_PACKAGE_INFO: {
      cardLayoutVersion: 2,
      benefitsTitle: 'Quyền lợi đang sở hữu'
    },
    TRAFFIC_FINE_PACKAGE_INFO: {
      showCardIconsLinkSupport: false
    },
    TRAFFIC_FINE_NOTIFICATION_SERVICES: {
      layoutVersion: 2
    },
    TRAFFIC_FINE_NOTIFICATION_VEHICLES: {
      layoutVersion: 2
    },
    AUTOMATED_TRAFFIC_FINE_NOTIFICATION_PAYMENT: {
      showTermsCheckbox: true,
      hidePaymentMethodSelector: true,
      buttonSubmitText: 'Thanh toán',
      headerTitle: 'Thanh toán',
      transactionFeeLabel: 'Phí giao dịch',
      isFreeTransactionFee: true,
      showVatNote: false,
      paymentMethodEmptyStateVariant: 2
    },
    TRAFFIC_FINE_REGISTRATION_MANAGEMENT: {
      headerStyleVersion: 2,
      firstTimeBannerVariant: 2,
      headerDescriptionText: 'Tự động thông báo lỗi phạt hằng tuần',
      showHeaderAddButton: false,
      showBottomRegisterButtonAlways: true,
      showBottomRegisterButtonIcon: true,
      showEmptyStateDescription: false,
      emptyStateTitle: 'Quý khách chưa có xe nào được đăng ký',
      showHomeBanner: false
    },
    TRAFFIC_FINE_PHONE_AUTH: {
      phoneAuthBannerVariant: 2
    }
  },
  TAMOVE: {
    TRAFFIC_FINE_REGISTRATION_MANAGEMENT: {
      headerDescriptionText: 'Tự động thông báo lỗi phạt hàng ngày'
    }
  }
}

/**
 * Xác định theme key — nếu theme không tồn tại trong config thì trả về 'DEFAULT'
 * @param {string} appThemeName - Tên theme (ví dụ: 'BIDV', 'TAMOVE', ...)
 * @returns {string} Theme key hợp lệ có trong config (hoặc 'DEFAULT')
 */
export function resolveThemeKey(appThemeName) {
  const key = String(appThemeName || '').toUpperCase()
  return APP_THEME_NAME_CONFIG[key] ? key : 'DEFAULT'
}

/**
 * Lấy config cho 1 feature, tự động merge DEFAULT + theme hiện tại.
 * Thuộc tính của theme hiện tại sẽ ghi đè lên DEFAULT.
 * @param {string} appThemeName - Tên theme
 * @param {string} featureKey - Tên tính năng (ví dụ: 'RESULT_CRIMINAL_CARD')
 * @returns {Object} Object cấu hình đã được merge
 */
export function getThemeFeatureConfig(appThemeName, featureKey) {
  const themeKey = resolveThemeKey(appThemeName)
  const defaultConfig = APP_THEME_NAME_CONFIG.DEFAULT?.[featureKey] || {}
  const themeConfig = APP_THEME_NAME_CONFIG[themeKey]?.[featureKey] || {}
  return { ...defaultConfig, ...themeConfig }
}
